import {
  TARGETING_GET_PURCHASING_POWER_REQUEST,
  TARGETING_GET_PURCHASING_POWER_SUCCESS,
  TARGETING_GET_PURCHASING_POWER_FAILURE,
  statusType
} from '../../../actions'

const initial = {
  data: null,
  status: statusType.IDLE
}

const purchasingPowerReducer = (state = initial, action) => {
  switch (action.type) {
    case TARGETING_GET_PURCHASING_POWER_REQUEST:
      return {
        ...state,
        data: action.payload,
        status: statusType.IN_PROGRESS
      }
    case TARGETING_GET_PURCHASING_POWER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: statusType.SUCCESS
      }
    case TARGETING_GET_PURCHASING_POWER_FAILURE:
      return {
        ...state,
        data: action.payload,
        status: statusType.ERROR
      }
    default:
      return state
  }
}

export default purchasingPowerReducer
